import { gql } from "@apollo/client";

/**
 * Removes the network scan documented on a node (IBM-1039): the node becomes
 * "not documented" and the nearest documented ancestor applies again. Not a
 * way to block — to block, document RED. Response carries `networkScan: null`.
 */
export const ClearNetworkScan = gql`
    mutation ClearNetworkScan($installedBaseNodeId: ID!) {
        clearNetworkScan(installedBaseNodeId: $installedBaseNodeId) {
            id
            canDocumentNetworkScan
            networkScan {
                state
                scanDate
                userName
            }
        }
    }
`;
